<template>
    <div :class="className" :style="{height:height,width:width}"/>
</template>

<script>
    import echarts from 'echarts'
    require('echarts/theme/macarons') // echarts theme
    import resize from './mixins/resize'

    const animationDuration = 2000
    export default {
        mixins: [resize],
        props: {
            className: {
                type: String,
                default: 'chart'
            },
            width: {
                type: String,
                default: '99%'
            },
            height: {
                type: String,
                default: '370px'
            },
            chartData: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                chart: null,
            }
        },
        watch: {
            chartData: {
                deep: true,
                handler(val) {
                    this.setOptions(val)
                }
            }
        },
        mounted() {
            this.$nextTick(() => {
                this.initChart()
            })
        },
        beforeDestroy() {
            if (!this.chart) {
                return
            }
            this.chart.dispose()
            this.chart = null
        },
        methods: {
            initChart() {
                this.chart = echarts.init(this.$el, 'macarons')
                this.setOptions(this.chartData)
            },
            setOptions({ dateTimeData,payedFeeData, refundFeeData} = {}) {
                this.chart.setOption({
                    // title: {
                    //     text: '单位:元',
                    // },
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: { // 坐标轴指示器，坐标轴触发有效
                            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
                        }
                    },
                    grid: {
                        top: 40,
                        left: '2%',
                        right: '2%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis: [{
                        type: 'category',
                        data:dateTimeData,
                        axisTick: {
                            alignWithLabel: true
                        }
                    }],
                    legend: {
                        data: ['实收(元)', '退款(元)']
                    },
                    yAxis: [{
                        type: 'value',
                        axisTick: {
                            show: false
                        }
                    }],
                    series: [{
                        name: '实收(元)',
                        type: 'bar',
                        stack: 'vistors',
                        barWidth: '50%',
                        data: payedFeeData,
                        animationDuration
                    }, {
                        name: '退款(元)',
                        type: 'bar',
                        stack: 'vistors',
                        barWidth: '50%',
                        data: refundFeeData,
                        animationDuration
                    }]
                })
            }

        }
    }
</script>
